import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';

import ForumIcon from '@material-ui/icons/Forum';

import { useStyles } from './styles';
import { COMMUNITY_FORUM } from '../../utils/constants';
import { COLORS } from '../../styles/constants';

const Footer = ({ appVersion }) => {
	const classes = useStyles();

	return (
		<footer>
			<Box
				display="flex"
				justifyContent="center"
				order={{
					xs: 1,
					sm: 1,
					md: 2,
					lg: 2,
					xl: 2
				}}
				className={classes.rootContainer}>
				<Typography display="inline" component="span">
					<ForumIcon fontSize="small" className={classes.contactIcon} />
				</Typography>

				<Typography variant="subtitle1" className={classes.emailLink}>
					<Link href={COMMUNITY_FORUM.url} target="_blank" underline="none" style={{ color: COLORS.LINK }}>
						{COMMUNITY_FORUM.label}
					</Link>
				</Typography>

				<Typography variant="subtitle1" className={classes.divider}>
					|
				</Typography>

				<Typography variant="subtitle1">{'v' + appVersion}</Typography>
			</Box>
		</footer>
	);
};

Footer.propTypes = {
	screenWidth: PropTypes.number.isRequired,
	appVersion: PropTypes.string.isRequired
};

export default Footer;
